"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.edit.title': 'Modifica Passo',
};
